import { create } from "zustand";
import { persist } from "zustand/middleware";

interface RelocationCreateDialogPreference {
  useStepsDialog: boolean;
  setUseStepsDialog: (useStepsDialog: boolean) => void;
}

export const useRelocationCreateDialogPreference =
  create<RelocationCreateDialogPreference>()(
    persist(
      (set) => ({
        useStepsDialog: true,
        setUseStepsDialog: (useStepsDialog) => set({ useStepsDialog }),
      }),
      {
        name: "imoova-relocation-create-dialog",
      },
    ),
  );
